<div *ngIf="allNotificationsConf" [class]="getClass()">
    <app-custom-iris-notification @fadeIn
                                  *ngFor="let i of allNotificationsConf; trackBy: trackByFn" [config]="i"
                                  (onCloseDialog)="closeNotif(i.id)">

    </app-custom-iris-notification>
</div>
